import { Component, Input, inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { SuggestedQuestionService } from '@eda/features/messenger/services/suggested-question-service';
import { IconsService } from '@eda/core/services/icons-service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'aiops-prompt-block',
  imports: [TranslatePipe],
  templateUrl: './prompt-block.html'
})
export class PromptBlock implements AfterViewInit {
  @ViewChild('promptIcon') promptIcon!: ElementRef<HTMLElement>;

  @Input() prompt = {
    icon: '',
    title: '',
    prompt: ''
  };

  private suggestedQuestionService = inject(SuggestedQuestionService);
  private iconsService = inject(IconsService);
  private translate = inject(TranslateService);

  ngAfterViewInit(): void {
      this.iconsService.getIcon(this.prompt.icon, this.promptIcon.nativeElement);
  }

  selectPrompt(promptOption: string) {
    const translatedPrompt = this.translate.instant(promptOption);
    this.suggestedQuestionService.updateSuggestion({text: translatedPrompt, autoSend: false});
  }

}
